import { PortalProvider, usePortal } from './PortalContext';
import { PortalLanding } from './PortalLanding';
import { PortalApp } from './PortalApp';

/** Entry point for the /approve route tree — no agency nav. */
export function PortalRoot() {
  return (
    <PortalProvider>
      <PortalGate />
    </PortalProvider>
  );
}

function PortalGate() {
  const { isAuthed } = usePortal();
  return isAuthed ? <PortalApp /> : <PortalLanding />;
}
